export enum PlateScanType{
   SOURCE="SOURCE", LYSIS="LYSIS", ALIQUOT="ALIQUOT", DNA="DNA", PGX="PGX", WGA="WGA", MAGMIX="MAGMIX", MERGE="MERGE", ARRAY="ARRAY", LAST="LAST"
}

export enum PopUpScanType{
   MACHINE="MACHINE", PLATE="PLATE"
}

export enum PlateScanFieldMapping{
   SOURCE="SOURCE", LYSIS="LYSIS", ALIQUOT="ALIQUOT", DNA="DNA", PGX="PGX", WGA="WGA", MAGMIX="MAGMIX", MERGE="MERGE", ARRAY="ARRAY"
}